import React, {Component} from 'react';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import {Card, Grid, Button, Icon, Table, Input} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {headerCellTitlesOfData} from '../static/commonStructures';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';

class EditSpecialPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'localSpecialPart': {'partNo': '', 'description': '', 'product': ''},
      'saveButtonDisabled': false,
    };
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.SpecialParts,
        scopes.Create
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    const {urlParams, fetchSpecialPartByPartno} = this.props;
    fetchSpecialPartByPartno(urlParams.partno);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.specialPart !== this.props.specialPart) {
      const {specialPart} = this.props;
      const specialPartCopy = cloneDeep(specialPart);
      this.setState({'localSpecialPart': specialPartCopy});
    }
    if (prevState.localSpecialPart !== this.state.localSpecialPart) {
      if (!this.state.localSpecialPart.product) {
        this.setState({'saveButtonDisabled': true});
      } else {
        this.setState({'saveButtonDisabled': false});
      }
    }
  }

  handleCancelClick() {
    this.props.goBack();
  }

  handleOnChange(event) {
    const {localSpecialPart} = this.state;
    const localSpecialPartCopy = cloneDeep(localSpecialPart);
    localSpecialPartCopy.product = event.target.value.toUpperCase();
    this.setState({'localSpecialPart': localSpecialPartCopy});
  }

  async handleSaveClick() {
    const {localSpecialPart} = this.state;
    const {editSpecialPart, goBack} = this.props;
    await editSpecialPart(localSpecialPart.partNo, localSpecialPart);
    goBack();
  }

  renderTitleAndHeader() {
    const {saveButtonDisabled} = this.state;

    return (
      <Card raised fluid>
        <Grid.Row>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.handleCancelClick} />
              <h2>Edición de productos especiales</h2>
              <div className='title-bar-actions'>
                <Button secondary onClick={this.handleCancelClick}>
                  Cancelar
                </Button>
                <Button
                  primary
                  onClick={this.handleSaveClick}
                  disabled={saveButtonDisabled}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Grid.Row>
      </Card>
    );
  }

  renderSpecialPartTable() {
    return (
      <Card fluid raised>
        <Table>
          {this.renderTableHeader()}
          {this.renderTableBody()}
        </Table>
      </Card>
    );
  }

  renderTableHeader() {
    return (
      <Table.Header>
        <Table.Row>{this.renderTableHeaderCells()}</Table.Row>
      </Table.Header>
    );
  }

  renderTableHeaderCells() {
    return headerCellTitlesOfData.map((header) => {
      return (
        <Table.HeaderCell
          key={`header${header.serializedName}`}
          textAlign='center'
        >
          {header.name}
        </Table.HeaderCell>
      );
    });
  }

  renderTableBody() {
    const {localSpecialPart} = this.state;
    if (!localSpecialPart) {
      return null;
    }

    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell textAlign='center'>{localSpecialPart.partNo}</Table.Cell>
          <Table.Cell textAlign='center'>{localSpecialPart.name}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Input
              value={localSpecialPart.product}
              onChange={this.handleOnChange.bind(this)}
              maxLength={headerCellTitlesOfData[1].maxLength}
              required={true}
            />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  render() {
    return (
      <div>
        {this.renderTitleAndHeader()}
        {this.renderSpecialPartTable()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'urlParams': ownProps.params,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
    'specialPart': state.specialParts.specialPart,
    'permissions': state.session.permissions,
  };
};

const {
  fetchSpecialPartByPartno,
  editSpecialPart,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchSpecialPartByPartno,
  editSpecialPart,
})(EditSpecialPart));
